import React, {useEffect, useState} from 'react'
import {Layout, LayoutChild,} from "../../../../palette/Palette";
import {Button} from "devextreme-react/button";
import format from 'date-fns/format'
import axios from "axios";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";
import Text from "../../../../palette/Text";
import {db} from "../../../../firebase/Firebase";
import Alerts from "../../../../palette/Alerts";
import {FilterDelete} from "../../../../utils/HelpFunctions";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://send-promotions-easi4xatjq-uc.a.run.app/send-promotions';


function SendPromotions(props) {

    const {companyName, idCompany, setPopupVisible, dataSource, contactNumbers, logoUrl} = props

    const [load, setLoad] = useState(false)
    const [textButton, setTextButton] = useState('Enviar promoción')
    const [passengers, setPassengers] = useState(null)
    const [success, setSuccess] = useState(false)

    const {enqueueSnackbar} = useSnackbar();

    const mainPath = db.collection(companyName).doc(idCompany).collection('PassengersManagement')

    useEffect(() => {
        let mounted = true;

        const GetDataPassengers = async () => {
            await mainPath.where("state", "==", 'Activo')
                .get()
                .then((querySnapshot) => {
                    const array = []
                    querySnapshot.forEach((doc) => {
                        const newObject = {
                            name: `${doc.data().name} ${doc.data().lastName}`, email: doc.data().email,
                            tokenPush: doc.data().tokenPush
                        }
                        array.push(newObject)
                    });
                    const filterNull = FilterDelete(array, 'tokenPush', null);
                    setPassengers(filterNull)
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
        }

        GetDataPassengers().catch(() => {
            //console.log("Error getting documents: ", error);
        });

        return () => {
            mounted = false
        }

    }, [])

    const sendPromotions = async () => {

        setTextButton('Enviando...')
        setLoad(true)

        const data = {promotion: dataSource, companyName, idCompany, contactNumbers, logoUrl, passengers: passengers}

        await axios.post(url, data, {headers: headers})
            .then((res) => {
                console.log(res.data)
                if (res.data === 'OK') {
                    setSuccess(true)
                    setTimeout(() => {
                        setSuccess(false)
                        setPopupVisible(false)
                        setLoad(false)
                        setTextButton('Enviar promoción')
                    }, 1500)

                } else {
                    setSuccess(false)
                    setTextButton('Enviar promoción')
                    setPopupVisible(false)
                    setLoad(false)
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                }
            }).catch((e) => {
                console.log(e)
                setSuccess(false)
                setTextButton('Enviar promoción')
                setPopupVisible(false)
                setLoad(false)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
    }

    return (
        <Layout color="transparent">
            {dataSource &&
            <Layout color="transparent">
                <LayoutChild row center>
                    <Text hover={false} size={14} weight={'700'} text={'Asunto :'}/>
                    <Text hover={false} size={12} weight={'600'} text={`${dataSource.tittle}`} left={7}/>
                </LayoutChild>
                <Text hover={false} size={10} weight={'600'} text={` Desde el ${format(dataSource.start, 'yyyy-MM-dd')} hasta el 
                ${format(dataSource.end, 'yyyy-MM-dd')}`} color={'gray'}/>
            </Layout>}

            <div style={{marginTop: 5}}/>
            <Layout>
                {success && <Alerts severity={'success'} body={'Promoción enviada exitosamente'}/>}
            </Layout>
            <div style={{marginTop: 5}}/>
            <Layout color="transparent" row center space>
                <Button
                    width={100}
                    height={30}
                    type="normal"
                    stylingMode="outlined"
                    disabled={load}
                    onClick={() => {
                        setLoad(false)
                        setPopupVisible(false)
                    }}
                >
                    <i className="far fa-arrow-alt-circle-left" style={{fontSize: '10px'}}/>
                    <span style={{fontSize: '10px', fontWeight: 'bold', marginLeft: 5}}>Salir</span>
                </Button>
                <Button
                    width={120}
                    height={30}
                    type="success"
                    disabled={load}
                    stylingMode="contained"
                    onClick={sendPromotions}
                >
                    <i className="far fa-check-circle" style={{fontSize: '10px'}}/>
                    <span style={{fontSize: '10px', fontWeight: 'bold', marginLeft: 5}}>{textButton}</span>
                </Button>
            </Layout>
        </Layout>
    )
}


export default SendPromotions
